import React from 'react';
import Heading from '../../components/Heading';
import MessagingLayout from './components/MessagingLayout';
import './client-messaging.scss';
function index() {
  return (
    <div>
        <Heading title="Client Messaging" />
        <MessagingLayout />
    </div>
  )
}

export default index